import { z } from "zod";
import { StageSchema } from "./Stage";

export const UpdateStageRequestSchema = StageSchema.pick({
    startDate: true,
    endDate: true
}).extend({
    accountId: z.number().positive().min(1)
});

export type UpdateStageRequest = z.infer<typeof UpdateStageRequestSchema>;
